/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { forwardRef } from "react";

import { css, cx } from "@panda/css";
import { Box } from "@panda/jsx";

import type { BoxProps } from "@panda/jsx";

export type CosmosClickableBoxProps = BoxProps;

const clickableBoxStyles = css({
	position: "relative",

	[`& button, & a[href]:not(.clickable-box__link)`]: {
		position: "relative",
		zIndex: 2,
	},
});

export const CosmosClickableBox = forwardRef<any, CosmosClickableBoxProps>(
	({ children, className, ...props }, forwardedRef) => {
		return (
			<Box {...props} className={cx(clickableBoxStyles, className)} ref={forwardedRef}>
				{children}
			</Box>
		);
	},
);

CosmosClickableBox.displayName = "CosmosClickableBox";
